import Typography from '@/common/components/base/typography/Typography';
import { Box } from 'styled-system/jsx';
import { GaugeChartPropsType } from './Chart.type';
import { useEffect, useState } from 'react';

export default function GaugeChart({
  value,
  totalFiles,
  startRange,
  EndRange,
}: GaugeChartPropsType) {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    requestAnimationFrame(() => {
      setDisplayValue(value);
    });
  }, [value]);

  const rotation = (displayValue / 5.2) * 180 - 90;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding="24px"
      position="relative"
    >
      <Box
        position="relative"
        width="300px"
        height="140px"
        overflow="hidden"
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
      >
        <Box
          position="absolute"
          top="0"
          width="281px"
          height="281px"
          borderRadius="50%"
          background={`conic-gradient(
            from 270deg,
            #ff5f5f 0deg,
            #ffbd47 45deg,
            #ffff54 90deg,
            #a3e635 135deg,
            #22c55e 180deg
          )`}
          maskImage="radial-gradient(farthest-side, transparent 75%, white 76%)"
          WebkitMaskImage="radial-gradient(farthest-side, transparent 75%, white 76%)"
        />

        <Box
          position="absolute"
          bottom="0"
          width="8px"
          height="35%"
          bg="black"
          borderRadius="281px"
          style={{
            transformOrigin: 'bottom center',
            transform: `rotate(${rotation}deg) translateX(5px) translateY(-180%)`,
            transition: 'transform 3s ease-out',
          }}
        />

        <Box position="absolute" bottom="0" left="25px">
          <Typography fontSize="12px" color="#fff">
            {startRange}
          </Typography>
        </Box>
        <Box position="absolute" bottom="0" right="25px">
          <Typography fontSize="12px" color="#fff">
            {EndRange}
          </Typography>
        </Box>
      </Box>

      <Box textAlign="center" mt="-80px">
        <Typography fontSize="32px" fontWeight="bold" color="#00A661">
          {value}
        </Typography>
        <Typography mt={2} textStyle="b1" color="black" fontWeight="700">
          امتیاز عملکرد
        </Typography>

        <Typography textStyle="b2" color="black" fontWeight="medium">
          از {totalFiles} پرونده
        </Typography>
      </Box>
    </Box>
  );
}
